export default __webpack_public_path__ + "static/media/load-hero-bg.237d0a95.png";